import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';

const AvatarDefaultExample = (): React.JSX.Element => {
	return <Avatar />;
};

export default AvatarDefaultExample;
